import { useSelector } from 'src/store';
import { selectors } from 'src/store/search';

export const usePageSizeState = () => ({
  dishPageSize: useSelector(selectors.selectDishPageSize),
  shefPageSize: useSelector(selectors.selectShefPageSize),
});
